// src/hooks/usePageContent.js
import { useState } from "react";
import {
  getCartByUser,
  addToCart,
  removeFromCart,
  updateCart as updateCartItem
} from "../services/cartService";

const useCart = () => {
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [addStatus, setAddStatus] = useState("idle");
  const [removeStatus, setRemoveStatus] = useState("idle");
  const [error, setError] = useState("");
  const [data, setData] = useState([]);

  const fetchCart = async (userId) => {
    setStatus("loading");
    setError("");

    try {
      const response = await getCartByUser(userId);

      if (response?.status !== "Error") {
        setData(response.data ?? response); // depending on API shape
        setStatus("done");
      } else {
        setStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const addCart = async (cartItem) => {
    setAddStatus("loading");
    setError("");
    // cart item
    // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "applicationUserId": "string",
    // "qty": 0
    try {
      const response = await addToCart(cartItem);

      if (response?.status !== "Error") {
        setAddStatus("done");
      } else {
        setAddStatus("error");
        setError(response?.message || response || "Something went wrong");
      }
    } catch (err) {
      setAddStatus("error");
      setError(err?.message || err || "Something went wrong");
    }
  };

  const updateCart = async (cartItem) => {
    setAddStatus("loading");
    setError("");
    // cart item
    // "productId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "variantCombinationId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    // "applicationUserId": "string",
    // "qty": 0
    try {
      const response = await updateCartItem(cartItem);

      if (response?.status !== "Error") {
        setAddStatus("done");
      } else {
        setAddStatus("error");
        setError(response?.message || response || "Something went wrong");
      }
    } catch (err) {
      setAddStatus("error");
      setError(err?.message || err || "Something went wrong");
    }
  };

  const removeCart = async (cartId) => {
    setRemoveStatus("loading");
    setError("");
    try {
      const response = await removeFromCart(cartId);

      if (response?.status !== "Error") {
        setRemoveStatus("done");
      } else {
        setRemoveStatus("error");
        setError(response?.message || "Something went wrong");
      }
    } catch (err) {
      setRemoveStatus("error");
      setError(err?.message || "Something went wrong");
    }
  };

  const resetStatus = () => {
    setStatus("idle");
    setAddStatus("idle");
    setRemoveStatus("idle");
    setError("");
  };

  return {
    fetchCart,
    addCart,
    updateCart,
    removeCart,
    data,
    status,
    addStatus,
    removeStatus,
    error,
    resetStatus,
  };
};

export default useCart;
